<template>
    <li class="accordion__item">
        <div
            class="accordion__trigger"
            :class="{ accordion__trigger_active: visible }"
            @click="open"
        >
            <slot name="accordion-trigger"></slot>
            <svg
                class="accordion__trigger--chevron"
                :style="chevronRotationStyle"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 5.41 9.41"
            >
                <polygon
                    points="0.71 9.41 0 8.71 4 4.71 0 0.71 0.71 0 5.41 4.71 0.71 9.41"
                ></polygon>
            </svg>
        </div>

        <transition
            name="accordion"
            @enter="start"
            @after-enter="end"
            @before-leave="start"
            @after-leave="end"
        >
            <div v-show="visible" class="accordion__content">
                <ul>
                    <slot name="accordion-content"></slot>
                </ul>
            </div>
        </transition>
    </li>
</template>

<script>
export default {
    components: {},
    props: {},
    inject: ['Accordion'],
    data() {
        return {
            index: null,
        };
    },
    computed: {
        chevronRotationStyle() {
            return {
                transform: `rotate(${this.visible ? 0.75 : 0.25}turn)`,
            };
        },
        visible() {
            return this.index === this.Accordion.active;
        },
    },
    created() {
        this.index = this.Accordion.count + 1;
        this.Accordion.count = this.index;
    },
    methods: {
        open() {
            if (this.visible) {
                this.Accordion.active = null;
            } else {
                this.Accordion.active = this.index;
            }
        },
        start(el) {
            // eslint-disable-next-line no-param-reassign,prefer-template
            el.style.height = el.scrollHeight + 'px';
        },
        end(el) {
            // eslint-disable-next-line no-param-reassign
            el.style.height = '';
        },
    },
};
</script>

<style lang="scss" scoped>
.accordion__item {
    cursor: pointer;
    padding: 5px 0;
    border-bottom: 1px solid $theme-color-primary-light;
}
.accordion__trigger {
    display: flex;
    justify-content: space-between;
    &--chevron {
        transform: rotate(90deg);
        max-height: 15px;
        width: 10px;
        margin-left: 8px;
        vertical-align: middle;
        polygon {
            fill: $theme-color-primary;
        }
    }
}
.accordion__content {
    ul {
        margin-left: 0px;
        padding-left: 0px;
        padding-right: 0px;
        padding-top: 0px;
        padding-bottom: 8px;
        list-style: none;
    }
}
</style>
